/**
* WYSIWYG One Col JS
* -----------------------------------------------------------------------------
*
* All the JS for the WYSIWYG One Col component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// import ScrollMagic from 'ScrollMagic';

( function( app ) {
  const COMPONENT = {

    className: 'wysiwyg-one-col',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'wysiwyg-one-col', COMPONENT );
} )( app );
